import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import Button, { BUTTON_HEIGHT_32 } from '../../Button'
import {
  EntityPhaseList,
  EntityPhaseListLoading,
  EntityProfileHeaderInfoItemBase,
} from '../../Entity'
import { QA_NAME_REQUEST_ARCHIVED_PIPELINES_MORE_BUTTON } from '../RequestArchivedPipelinesModal'
import { isRequestProfileHeaderInfoItemNameBuilding } from '../RequestProfileHeaderInfoItem'

import {
  getRequestProfileHeaderInfoItemsColumnsCount,
  isRequestProfileHeaderInfoItemsBuildingSpanning,
} from './RequestProfileHeaderInfoItems.utils'

import * as styles from './RequestProfileHeaderInfoItems.module.css'

import MoreVerticalIcon from '../../../icons/more-vertical.svg'

function RequestProfileHeaderInfoItems({
  archivedPipelinesCount,
  arePhasesLoading,
  className,
  handlers,
  isLoading,
  itemActionsProps,
  items,
  loadingItemsLength,
  phaseListProps,
  phases,
  renderItem,
  onClickOpenArchivedPipelinesModal,
}) {
  const { t } = useTranslation()

  const columnsCount = getRequestProfileHeaderInfoItemsColumnsCount(items)

  const isBuildingSpanning =
    isRequestProfileHeaderInfoItemsBuildingSpanning(columnsCount)

  const gridClassName = classNames(styles.infoGrid, className)
  const gridStyle = {
    '--request-profile-header-info-items-columns': columnsCount,
  }

  return (
    <>
      {isLoading || arePhasesLoading ? (
        <div className={styles.pipeline}>
          <EntityPhaseListLoading />
        </div>
      ) : phases?.length > 0 ? (
        <div className={styles.pipeline}>
          <EntityPhaseList
            {...phaseListProps}
            items={phases}
            phaseItemClassName={styles.phaseItem}
          />
          {archivedPipelinesCount > 0 ? (
            <Button.Contained
              isGrey
              beforeIconProps={{ Icon: MoreVerticalIcon }}
              height={BUTTON_HEIGHT_32}
              qaName={QA_NAME_REQUEST_ARCHIVED_PIPELINES_MORE_BUTTON}
              tooltip={t('RequestProfile.ArchivedPipelinesButtonTooltipKey')}
              tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
              onClick={onClickOpenArchivedPipelinesModal}
            />
          ) : null}
        </div>
      ) : null}
      <div className={gridClassName} style={gridStyle}>
        {isLoading
          ? Array.from({ length: loadingItemsLength }).map((_, index) => (
              <div className={styles.infoGridItem} key={index}>
                <EntityProfileHeaderInfoItemBase
                  isLoading
                  className={styles.infoItemBase}
                />
              </div>
            ))
          : items?.map(item => (
              <div
                className={classNames(styles.infoGridItem, {
                  [styles.infoGridItemBuilding]:
                    isBuildingSpanning &&
                    isRequestProfileHeaderInfoItemNameBuilding(item.name),
                })}
                key={item.name}
              >
                {renderItem?.({
                  ...item,
                  className: styles.infoItemBase,
                  handlers: handlers?.[item.name],
                  itemActionsProps,
                })}
              </div>
            ))}
      </div>
    </>
  )
}

export default RequestProfileHeaderInfoItems
